export const enComponentLibraryBannerComponents = {
    componentLibrary: {
        molecules: {
            appBar: {
                banner: {
                    showDetails: 'Show details',
                    hideDetails: 'Hide details',
                    close: 'Close banner',
                },
            },
        },
    },
}
